import { render, staticRenderFns } from "./LogisticsTrackingDialog.vue?vue&type=template&id=a0afe036&scoped=true"
import script from "./LogisticsTrackingDialog.vue?vue&type=script&lang=js"
export * from "./LogisticsTrackingDialog.vue?vue&type=script&lang=js"
import style0 from "./LogisticsTrackingDialog.vue?vue&type=style&index=0&id=a0afe036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0afe036",
  null
  
)

export default component.exports